"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Animate_1 = require("../../Animate");

var EnterEmail_1 = __importDefault(require("../EnterEmail"));

var EnterPassword_1 = __importDefault(require("../EnterPassword"));

var Loader_1 = __importDefault(require("../../Loader"));

var hook_1 = __importDefault(require("./hook"));

var classnames_1 = __importDefault(require("classnames"));

exports.default = function (_a) {
  var onSuccess = _a.onSuccess,
      className = _a.className,
      inputClassName = _a.inputClassName,
      buttonClassName = _a.buttonClassName,
      loaderClassName = _a.loaderClassName;

  var _b = hook_1.default(onSuccess),
      step = _b.step,
      loading = _b.loading,
      error = _b.error,
      email = _b.email,
      password = _b.password,
      passwordConfirmation = _b.passwordConfirmation,
      setEmail = _b.setEmail,
      setPassword = _b.setPassword,
      setPasswordConfirmation = _b.setPasswordConfirmation,
      next = _b.next;

  var onSubmit = function onSubmit(ev) {
    ev.preventDefault();
    next();
  };

  return react_1.default.createElement("form", {
    className: classnames_1.default('d-flex flex-column', className),
    onSubmit: onSubmit
  }, step === 0 ? react_1.default.createElement(Animate_1.SlideInLeft, {
    id: 'email'
  }, react_1.default.createElement(EnterEmail_1.default, {
    className: inputClassName,
    value: email,
    onChange: setEmail
  })) : step === 1 ? react_1.default.createElement(Animate_1.SlideInLeft, {
    id: 'password'
  }, react_1.default.createElement(EnterPassword_1.default, {
    className: inputClassName,
    label: 'ENTER YOUR PASSWORD',
    value: password,
    onChange: setPassword
  })) : step === 2 ? react_1.default.createElement(Animate_1.SlideInLeft, {
    id: 'passwordConfirmation'
  }, react_1.default.createElement(EnterPassword_1.default, {
    className: inputClassName,
    label: 'CONFIRM YOUR PASSWORD',
    value: passwordConfirmation,
    onChange: setPasswordConfirmation
  })) : react_1.default.createElement("div", null), react_1.default.createElement("p", {
    className: 'text-danger'
  }, error), react_1.default.createElement("div", {
    className: 'col d-md-none'
  }), loading ? react_1.default.createElement("div", {
    className: classnames_1.default('text-center', loaderClassName)
  }, react_1.default.createElement(Loader_1.default, null)) : react_1.default.createElement(Animate_1.SlideInLeft, {
    id: 'continue'
  }, react_1.default.createElement("button", {
    type: 'submit',
    className: classnames_1.default('btn w-100', buttonClassName)
  }, "Continue")));
};